import { ITradeTypeMappedItem } from './interfaces/i.trade-type.mapped';
import { BaseMappedItem } from '../base/base-mapped-item';
import { ITradeTypesLogicService } from './interfaces/i.trade-types.logic.service';
import { DtoProp } from '../base/dto-prop.decorator';
import { IComplianceRegistrationDto, ITradeTypeDto } from '@classictechsolutions/hubapi-transpiled-enums';

export class TradeTypeMappedItem
    extends BaseMappedItem<ITradeTypeDto, ITradeTypeMappedItem, ITradeTypesLogicService>
    implements ITradeTypeMappedItem {
    @DtoProp public canRequestSevenDayPayments: boolean;
    @DtoProp public includeInLiveSchedule: boolean;
    @DtoProp public id: number;
    @DtoProp public isActive: boolean;
    @DtoProp public label: string;
    @DtoProp public parentId: number;
    @DtoProp public parentLabel: string;
    @DtoProp public requiredComplianceRegistrations: IComplianceRegistrationDto[];

    constructor(
        sourceData: ITradeTypeDto,
        logicService: ITradeTypesLogicService
    ) {
        super(sourceData, logicService, TradeTypeMappedItem, {
            requiredComplianceRegistrations: [],
            isActive: true,
            canRequestSevenDayPayments: false,
            includeInLiveSchedule: false,
        });
    }
}
